angular.module('zc.commonApi')
  .factory('InterestWidgetStats', InterestWidgetStats);

const FIELD_NAMES = [
  'all',
  'iw_click_item',
  'iw_started',
  'iw_use',
  'no_iw_use'
];

InterestWidgetStats.$inject = ['FacadeV2', 'lib'];
function InterestWidgetStats(FacadeV2, lib) {
  return { find, findByFilters, transform };

  function find(paths, params) {
    return FacadeV2.request(
      `/apikeys/${paths.apikey}/interest_widget_stats/daily/find`,
      {params}
    )
      .then(res => res.data)
      .then(stats => _sumByStartAt(stats));
  }

  function findByFilters(apikey, filters) {
    return find({ apikey }, {
      match: {
        device: filters.device,
        campaign_segment_id: null,
        start_at: {
          $gte: moment(filters.start_at).toDate(),
          $lt: moment(filters.end_at).endOf('day').toDate()
        }
      }
    });
  }

  function transform(stat) {
    if(_.keys(stat).length === 0) return stat;
    FIELD_NAMES.forEach(fieldName => {
      const field = stat[fieldName];
      if(field.session_count !== 0) {
        field.conversion_rate = field.conversion_count / field.session_count * 100;
        field.cart_button_click_rate = field.cart_button_click_count / field.session_count * 100;
        field.nocv_session_rate = field.nocv_session_count / field.session_count * 100;
        field.onecv_session_rate = field.onecv_session_count / field.session_count * 100;
        field.loyal_session_rate = field.loyal_session_count / field.session_count * 100;
        field.average_item_count = field.item_count / field.session_count;
      } else {
        field.conversion_rate = field.cart_button_click_rate = field.nocv_session_rate = field.onecv_session_rate = field.loyal_session_rate = field.average_item_count = 0;
      }
      field.average_conversion_price = (field.conversion_count !== 0) ? field.conversion_price / field.conversion_count : 0;
      field.conversion_price_with_campaign_rate = (field.conversion_price !== 0) ? field.conversion_price_with_campaign / field.conversion_price * 100 : 0;
      field.utm_medium_rate_map = {};
      _.keys(field.utm_medium_count_map).forEach(key => {
        field.utm_medium_rate_map[key] = (field.session_count !== 0) ? (field.utm_medium_count_map[key] / field.session_count * 100) : 0;
      });
    });
    stat.sales_rate = (stat.all.conversion_price !== 0) ? (stat.iw_click_item.conversion_price / stat.all.conversion_price * 100) : 0;
    stat.iw_started_rate = (stat.all.session_count !== 0) ? (stat.iw_started.session_count / stat.all.session_count * 100) : 0;
    stat.iw_use_rate = (stat.iw_started.session_count !== 0) ? (stat.iw_use.session_count / stat.iw_started.session_count * 100) : 0;
    stat.conversion_up_rate = (stat.no_iw_use.conversion_rate !== 0) ? (stat.iw_use.conversion_rate / stat.no_iw_use.conversion_rate * 100) : 0;
    return stat;
  }

  // NOTE:
  // combine the counts per day
  // because there might be results for multiple devices per day (PC+tablet)
  function _sumByStartAt(stats) {
    return _.chain(stats)
      .groupBy('start_at')
      .map(val => lib.sumCountMap(val))
      .value();
  }
}



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/common_api/facade/interest_widget_stats.service.js